'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AUINav = require('./AUINav');

var _AUINav2 = _interopRequireDefault(_AUINav);

var _AUINavHeading = require('./AUINavHeading');

var _AUINavHeading2 = _interopRequireDefault(_AUINavHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUISidebarGroup = function AUISidebarGroup(_ref) {
    var groupId = _ref.groupId,
        tier = _ref.tier,
        heading = _ref.heading,
        options = _ref.options,
        children = _ref.children,
        className = _ref.className;

    var classes = (0, _classnames2.default)('aui-sidebar-group', 'aui-sidebar-group-tier-' + tier, groupId, className);

    var header = typeof heading === 'string' ? _react2.default.createElement(
        _AUINavHeading2.default,
        null,
        heading
    ) : heading;

    return _react2.default.createElement(
        'div',
        { id: groupId, style: { paddingTop: 15 }, className: classes },
        _react2.default.createElement(
            'div',
            { className: 'aui-navgroup-inner' },
            header,
            _react2.default.createElement(
                _AUINav2.default,
                { options: options },
                children
            )
        )
    );
};

AUISidebarGroup.displayName = 'AUISidebarGroup';
AUISidebarGroup.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    options: _propTypes2.default.array,
    groupId: _propTypes2.default.string.isRequired,
    heading: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    tier: _propTypes2.default.string
};

AUISidebarGroup.defaultProps = {
    tier: 'one'
};

exports.default = AUISidebarGroup;
//# sourceMappingURL=AUISidebarGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUISidebarGroup.js
// module id = 197
// module chunks = 0